export const LIB_VERSION = '15.5.1'; // autogenerated 
//# sourceMappingURL=version.js.map